// Plausible — laddas först efter att besökaren accepterat alla cookies.
// Skriptet är kakfritt, men vi håller samma samtyckesregel för alla
// mätverktyg så bilden blir konsekvent i granskningar.

const SRC =
  "https://plausible.io/js/script.hash.outbound-links.file-downloads.tagged-events.js";

let loaded = false;

export function loadPlausible(): void {
  if (typeof window === "undefined" || loaded) return;
  if (document.querySelector(`script[src="${SRC}"]`)) {
    loaded = true;
    return;
  }
  loaded = true;

  const w = window as unknown as { plausible?: ((...a: unknown[]) => void) & { q?: unknown[] } };
  if (!w.plausible) {
    const queue = ((...args: unknown[]) => {
      (queue.q = queue.q || []).push(args);
    }) as ((...a: unknown[]) => void) & { q?: unknown[] };
    w.plausible = queue;
  }

  const script = document.createElement("script");
  script.defer = true;
  script.src = SRC;
  script.setAttribute("data-domain", "fenny.se");
  document.head.appendChild(script);
}

/** Laddar Plausible om besökaren redan tidigare tackat ja till alla cookies. */
export function loadPlausibleIfConsented(): void {
  if (typeof window === "undefined") return;
  try {
    if (localStorage.getItem("fenny_consent") === "all") loadPlausible();
  } catch {
    /* storage blockerad — mät inte */
  }
}
